import { mapActions } from 'vuex';
import Events from '_utils/events';
import LeadService from '_services/rest/modules/lead';

export default {
  name: 'lead-actions',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      LeadService.deleteLead(this.selectLead)
        .then(() => {
          this.close();
          this.$router.push('/admin/indicacoes/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Indicação deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    toggleSpam(model) {
      const status = (model.status === 'spam') ? 'new' : 'spam';
      LeadService.toggleSpam(model.id, status)
        .then(() => {
          Events.$emit('update:pagination', { page: this.$route.params.page });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    toggleFinished(model) {
      const finished = (model.finished === 0) ? 1 : 0;
      LeadService.toggleFinished(model.id, finished)
        .then(() => {
          Events.$emit('update:pagination', { page: this.$route.params.page });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
};
